/* global axios */
/* eslint-disable max-classes-per-file */
import ApiClient from './ApiClient';

class TalkviaContractTemplatesAPI extends ApiClient {
  constructor() {
    super('talkvia_contract_templates', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  create(data) {
    return axios.post(this.url, { talkvia_contract_template: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, {
      talkvia_contract_template: data,
    });
  }
}

class TalkviaContractsAPI extends ApiClient {
  constructor() {
    super('talkvia_contracts', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  create(data) {
    return axios.post(this.url, { talkvia_contract: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { talkvia_contract: data });
  }

  sendLink(id, data = {}) {
    return axios.post(`${this.url}/${id}/send_link`, {
      talkvia_contract: data,
    });
  }

  sendMapLink(id, data = {}) {
    return axios.post(`${this.url}/${id}/send_map_link`, {
      talkvia_contract: data,
    });
  }

  sendQuote(data = {}) {
    return axios.post(`${this.url}/send_quote`, {
      talkvia_contract: data,
    });
  }

  generateReceipt(data) {
    return axios.post(`${this.url}/generate_receipt`, {
      talkvia_contract: data,
    });
  }

  sendReceipt(data = {}) {
    return axios.post(`${this.url}/send_receipt`, { talkvia_contract: data });
  }

  credits() {
    return axios.get(`${this.url}/credits`);
  }

  signatureLevels() {
    return axios.get(`${this.url}/signature_levels`);
  }

  updateStatus(id, status, reason) {
    return axios.patch(`${this.url}/${id}/status`, {
      talkvia_contract: { status, ...(reason ? { reason } : {}) },
    });
  }

  markGovSigned(id, data) {
    return axios.post(`${this.url}/${id}/mark_gov_signed`, {
      talkvia_contract: data,
    });
  }
}

export const ContractTemplatesAPI = new TalkviaContractTemplatesAPI();
export const ContractsAPI = new TalkviaContractsAPI();
